import React from 'react';
import './SiderStyle.css';

const Sider = ({ open, setOpen, children }) => {
    const handleBackdropClick = () => {
        setOpen(false);
    };

    const handlePanelClick = (e) => {
        e.stopPropagation();
    };

    return (
        <div
            className={`sider-container ${open ? 'open' : ''}`}
            onClick={handleBackdropClick}
        >
            <div className="sider-panel" onClick={handlePanelClick}>
                <button className="sider-close-btn" onClick={handleBackdropClick}>
                    &times;
                </button>

                <div className="sider-content">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Sider;
